import { ToolkitAccordion } from "@/components/sections/toolkit-accordion";

/* ── Values Accordion Symbol ─────────────────────────────────── */
/*
  "The AdVenture Way" — company values as an accordion.
  True symbol: all content hardcoded, no content props.
  Uses ToolkitAccordion component with values items.
*/

const VALUES = [
  {
    title: "Curiosity",
    body: "We enjoy learning new things. We take walks, naps, and meditate. We want to share what we learn with others, and those we share with gravitate toward our magnetic force of knowledge. If you stop learning, you stop growing. We don't stop.",
  },
  {
    title: "Positive Energy",
    body: "We celebrate each other's victories. We don't mope, brood, sulk, despair, gloom or grump. We are not curmudgeonly malcontents. Our office is a place of joy and uplift... because it's comprised of joyful, positive and uplifting souls.",
  },
  {
    title: "Intellectual Honesty",
    body: "We are not afraid of what we don't know. We blame ourselves first. And second. And third. We can criticize ourselves in the face of success. All the more so in the face of failure. We admit it, and act accordingly. We listen... as if the person we're talking to has something worth hearing.",
  },
  {
    title: "AI With Human Taste",
    body: "We build with AI every day. We ship with it. We win with it. But AI without human judgment is just expensive automation. Our strategists bring decades of experience, pattern recognition, and creative instinct that no model can replicate. Elite humans wielding elite tools. That's the model.",
  },
  {
    title: "Idiotic Optimism",
    body: "We can. We will. Even when the odds are stacked against us. We pop off the runner's block, and figure it out once we're in motion. It's the fantastical over the statistic. We pursue not what is rational or pragmatic or sensible, but what is great and spectacular.",
  },
];

export interface ValuesAccordionProps {
  className?: string;
}

export function ValuesAccordion({ className }: ValuesAccordionProps) {
  return (
    <ToolkitAccordion
      headline="The AdVenture Way"
      items={VALUES}
      dark
      defaultOpen={0}
      className={className}
    />
  );
}
